<script>
import { liveChatHours } from '@utils/appConstants'
import { chatMethods } from '@state/helpers'

export default {
  components: {},
  props: {
    isLink: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    isChatAvailable: false,
    isSalesforceAvailable: false,
    liveagentReady: false,
    checkingInterval: null,
  }),
  computed: {},
  watch: {
    liveagentReady: function(data) {
      if (data) {
        clearInterval(this.checkingInterval)
        this.initChat()
      }
    },
    deep: true,
  },
  created() {
    this.isChatAvailable = this.chatAvailableCheck()
    if (!window._laq) {
      let localThis = this
      /*eslint-disable */
      this.checkingInterval = setInterval(function() {
        if (liveagent) {
          localThis.liveagentReady = true
          clearInterval(localThis.checkingInterval)
        }
      }, 500)
      /*eslint-disable */
    }
  },
  methods: {
    ...chatMethods,
    initChat() {
      /*eslint-disable */
      this.initializeChat(this.isLink).then((response) => {
        try {
          liveagent.init(
            'https://d.la2c1.salesforceliveagent.com/chat',
            '572i0000000XZJf',
            '00Di0000000faSr'
          )
          this.isSalesforceAvailable =
            document.getElementById('liveagent_text_online_573i0000000XZJk')
              .style.display === ''
        } catch (error) {}
      })
      /*eslint-disable */
    },
    openChat(id) {
      /*eslint-disable */
      liveagent.startChat(id)
      /*eslint-disable */
    },
    chatAvailableCheck() {
      let currentDay = new Date().getDay()
      let currentHour = new Date().getHours()

      if (
        currentDay !== liveChatHours.saturday &&
        currentDay !== liveChatHours.sunday &&
        (currentHour >= liveChatHours.openHour &&
          currentHour <= liveChatHours.closeHour)
      )
        return true
      else return false
    },
  },
}
</script>

<template>
  <div>
    <div v-if="isLink && isChatAvailable">
      <!-- online -->
      <img
        id="liveagent_button_online_573i0000000XZJk"
        title="Live Chat is Online"
        :class="{ 'd-inline': isSalesforceAvailable }"
        style="display: none; border: 0 none; cursor: pointer;padding-top:0;padding-right:5px; font-weight: normal;"
        src="https://experianproductrequest.secure.force.com/resource/1449682835000/Auto_LiveChatOnlineConsumer"
        @click="openChat('573i0000000XZJk')"
      />

      <a
        id="liveagent_text_online_573i0000000XZJk"
        href="javascript://Chat"
        :class="{ 'd-inline': isSalesforceAvailable }"
        title="Live Chat is Online"
        style="display: none; margin:0 0 0 0;border-right:1px solid #000;padding: 0 6px 0 0; font-weight: normal;"
        @click="openChat('573i0000000XZJk')"
        >Chat Now</a
      >

      <!-- offline -->
      <img
        id="liveagent_button_offline_573i0000000XZJk"
        title="Live Chat is Currently Unavailable"
        :class="{ 'd-none': isSalesforceAvailable }"
        style="border: 0 none;padding-top:0; padding-right:5px; font-weight: normal;"
        src="https://experianproductrequest.secure.force.com/resource/1449682785000/Auto_LiveChatOffline"
      />
      <div
        id="liveagent_text_offline_573i0000000XZJk"
        title="Live Chat is Currently Unavailable"
        :class="[{ 'd-none': isSalesforceAvailable }, $style.agentofflinetext]"
        style="float:right;border-right:1px solid #000;padding-right: 6px; font-weight: normal;"
        >Chat</div
      >
    </div>
    <div v-else-if="!isLink && isChatAvailable">
      <div :id="$style.chatRightRail">
        <p class="livechat">
          <span
            id="liveagent_text_online_573i0000000XZJkX"
            style="display: none; border: 0 none;"
          >
            &nbsp;&nbsp; Chat with an AutoCheck
            <br />&nbsp;&nbsp; representative now.
          </span>
          <span
            id="liveagent_text_offline_573i0000000XZJkX"
            style="display: block; border: 0 none;"
          >
            &nbsp;&nbsp; Chat with an AutoCheck
            <br />&nbsp;&nbsp; representative.
          </span>
          <img
            id="liveagent_button_online_573i0000000XZJkX"
            :class="$style.chatNow"
            title="Live Chat is Online"
            style="display: none; border: 0 none; cursor: pointer;"
            src="@assets/images/chat_now.png"
            class="chat-now"
            @click="openChat('573i0000000XZJk')"
          />
          <img
            id="liveagent_button_offline_573i0000000XZJkX"
            :class="$style.chatOff"
            title="Live Chat is Currently Unavailable"
            style="display: block; border: 0 none;"
            src="@assets/images/chat_offline.png"
            class="chat-off"
          />
        </p>
      </div>
    </div>
    <div v-else-if="!isLink && !isChatAvailable">
      <p :class="$style.chatOutsideHours">
        <span>
          <strong>Live Chat is open Monday through Friday.</strong>
          <br />
          <br />We'd love to chat with you then.
        </span>
      </p>
    </div>
  </div>
</template>

<style lang="scss" module>
@import '@design';

.chatNow {
  display: block;
  width: 117px;
  height: 45px;
  padding: 0;
  margin-top: 10px;
  margin-left: 10px;
  text-indent: -9999px;
  background: url(@assets/images/chat-box-online-btn-117x88.png) no-repeat
    scroll 0 0 transparent;
  border: 0 none;
}

.chatOff {
  display: block;
  width: 117px;
  height: 45px;
  padding: 0;
  margin-top: 10px;
  margin-left: 10px;
  text-indent: -9999px;
  background: url(@assets/images/chat-box-offline-btn-117x88.png) no-repeat
    scroll 0 0 transparent;
  border: 0 none;
}

#chatRightRail {
  width: 100%;
  height: auto;
  min-height: 220px;
  padding-bottom: 1px;
  background: url(@assets/images/chat-agent-box-229x162.png) no-repeat scroll 0
    0 transparent;
  background-size: 100%;
}

.chatOutsideHours {
  width: 100%;
  padding: 33px 15px;
  font-size: 14px;
  background: #f1f1f1; /* Old browsers */
  background: -moz-linear-gradient(
    top,
    #f1f1f1 0%,
    #fafafa 30%,
    #ffffff 100%
  ); /* FF3.6-15 */
  background: -webkit-linear-gradient(
    top,
    #f1f1f1 0%,
    #fafafa 30%,
    #ffffff 100%
  ); /* Chrome10-25,Safari5.1-6 */
  background: linear-gradient(
    to bottom,
    #f1f1f1 0%,
    #fafafa 30%,
    #ffffff 100%
  ); /* W3C, IE10+, FF16+, Chrome26+, Opera12+, Safari7+ */
  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#f1f1f1', endColorstr='#ffffff',GradientType=0 ); /* IE6-9 */
  border: 1px solid #c7c7c7;
  border-radius: 5px;
}

.livechat span {
  display: inline-block;
  padding-top: 50px;
  font-size: 12px;
  font-style: italic;
  color: #808080;
}

.agentofflinetext {
  color: #808080 !important;
  text-decoration: none !important;
}
</style>
